var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge",class:_vm.jobLabelClass},[_vm._v("\n  "+_vm._s(_vm.job.type?.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }